/** Regulár pro kontrolu validního roku (1000 - 9999) */
import { IOperation, IReplaceItemData } from "./FilterInterfaces";
import { FilterRegistrations } from "./FilterRegistrations";

export const YEAR_CHECK_REGEXP = /^\s*(100\d|10[1-9]\d|1[1-9]\d{2}|[2-9]\d{3})\s*$/;
/** Regulár pro kontrolu validního roku a měsíce */
export const YEAR_WITH_MONTH_CHECK_REGEXP = /^\s*(0?[1-9]|1[0-2])\s*\.\s*(100\d|10[1-9]\d|1[1-9]\d{2}|[2-9]\d{3})\s*$/;

export function dateTimeFilterRecreateFunction(value: any, operation: IOperation) {
    const returnData: IReplaceItemData[] = [];

    if (operation.id !== "is") return [];

    if (YEAR_CHECK_REGEXP.test(value)) {
        const dateResult = YEAR_CHECK_REGEXP.exec(value);
        returnData.push({ values: FilterRegistrations.createValuesFromData("date", "years", dateResult[1]), operation: "years" });
    } else if (YEAR_WITH_MONTH_CHECK_REGEXP.test(value)) {
        const dateResult = YEAR_WITH_MONTH_CHECK_REGEXP.exec(value);
        returnData.push({ values: FilterRegistrations.createValuesFromData("date", "months", dateResult[1]), operation: "months", operator: "and" });
        returnData.push({ values: FilterRegistrations.createValuesFromData("date", "years", dateResult[2]), operation: "years", operator: "and" });
    }

    return returnData;
}
